import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
export function useBankSlipPayment() {
    const navigate = useNavigate();
    const [isNavigatingToBankSlip, setIsNavigatingToBankSlip] = useState(false);
    const [error, setError] = useState(null);
    const navigateToBankSlipFlow = (rechargeId) => {
        try {
            setIsNavigatingToBankSlip(true);
            setError(null);
            navigate(`/beneficios/recarga/${rechargeId}/pagar/boleto`, {
                state: {
                    rechargeId,
                },
            });
        }
        catch (err) {
            setError('Error navigating to Bank Slip flow');
            setIsNavigatingToBankSlip(false);
        }
    };
    return {
        isNavigatingToBankSlip,
        navigateToBankSlipFlow,
        error,
    };
}
